import { useSelectors } from '../store'
import { useLivePrice } from './use-live-price'
import { surchargeLines } from './price-lines'

// The large-car and same-day lines for the booking as it stands
// (lib/price-lines.js), from the store's chosen surcharges and their live
// prices.
export const useSurchargeLines = () => {
  const { largeCar, sameDay } = useSelectors()
  const priceFor = useLivePrice()
  return surchargeLines({
    largeCar: largeCar ? priceFor('Extra for large car') : null,
    sameDay: sameDay ? priceFor('Extra for same day') : null
  })
}
